document.addEventListener('DOMContentLoaded', function () {
  function initStickyFilters() {
    const tab = document.querySelector('.cc-filters');
    const results = document.querySelector('.cc-filters-results .grid-layout');
    if (!tab || !results) return;

    const minWidth = 768;
    const wrapper = tab.closest('.cc-filters-main') || tab.parentElement;

    if (getComputedStyle(wrapper).position === 'static') {
      wrapper.style.position = 'relative';
    }

    let savedLeftOffset = 0; // NEW: Offset from the wrapper's left edge
    let savedWidth = 0;

    function measureFilters() {
      // Temporarily remove dynamic styles for accurate measurement
      const prevPosition = tab.style.position;
      tab.style.position = '';
      tab.style.left = '';
      tab.style.width = '';
      
      const tabRect = tab.getBoundingClientRect();
      const wrapperRect = wrapper.getBoundingClientRect();
      
      // *** REVISED CALCULATION ***
      // Calculate the left offset of the tab *relative to its positioned wrapper*.
      // This value should remain consistent regardless of scroll position.
      savedLeftOffset = tabRect.left - wrapperRect.left;
      savedWidth = tabRect.width;
      
      tab.style.position = prevPosition;
    }

    const topOffset = 110; // gap from top of viewport

    function handleSticky() {
      if (window.innerWidth < minWidth) {
        tab.removeAttribute('style');
        tab.classList.remove('is-fixed');
        return;
      }

      const scrollY = window.scrollY;
      const resultsRect = results.getBoundingClientRect();
      const tabHeight = tab.offsetHeight;

      // Absolute position of the results container relative to the document
      const resultsTopAbsolute = scrollY + resultsRect.top;
      const resultsBottomAbsolute = scrollY + resultsRect.bottom;

      // Stick starts when viewport scrolls past the result top, minus the offset
      const stickStart = resultsTopAbsolute - topOffset;
      // Stick ends when the bottom of the filter hits the bottom of the results
      const stickEnd = resultsBottomAbsolute - tabHeight - topOffset;

      // Skip sticky if results are too short
      if (resultsRect.height <= tabHeight) {
        tab.removeAttribute('style');
        tab.classList.remove('is-fixed');
        return;
      }

      if (scrollY >= stickStart && scrollY <= stickEnd) {
        // --- FIXED POSITION STATE (Sticking) ---
        tab.style.position = 'fixed';
        tab.style.top = topOffset + 'px';
        
        // Use rect.left to get the current viewport left position
        // This is the most reliable way for fixed elements.
        const wrapperRectFixed = wrapper.getBoundingClientRect();
        tab.style.left = wrapperRectFixed.left + savedLeftOffset + 'px';
        tab.style.width = savedWidth + 'px';
        tab.classList.add('is-fixed');
        
      } else if (scrollY > stickEnd) {
        // --- ABSOLUTE POSITION STATE (Bottomed out) ---
        tab.style.position = 'absolute';
        
        // Positioned relative to the wrapper, so 'top' is easy
        tab.style.top = (results.offsetHeight - tabHeight) + 'px';
        
        // Use the saved offset relative to the wrapper
        tab.style.left = savedLeftOffset + 'px'; 
        tab.style.width = savedWidth + 'px';
        tab.classList.remove('is-fixed');
        
      } else {
        // --- STATIC/DEFAULT POSITION STATE ---
        tab.removeAttribute('style');
        tab.classList.remove('is-fixed');
      }
    }

    // Clean up previous event listeners (good practice)
    window.removeEventListener('resize', handleSticky);
    window.removeEventListener('scroll', handleSticky);

    // Add new listeners
    window.addEventListener('resize', () => {
      measureFilters();
      handleSticky();
    });
    window.addEventListener('scroll', handleSticky, { passive: true });

    // Initial run
    measureFilters();
    handleSticky();
  }

  // Initial run
  initStickyFilters();

  // Re-run on Shopify filter reload
  document.addEventListener('shopify:section:load', initStickyFilters);
  document.addEventListener('shopify:section:render', initStickyFilters);
  document.addEventListener('cc:filters:updated', initStickyFilters);

  // MutationObserver fallback for dynamic content
  const resultsContainer = document.querySelector('.cc-filters-results');
  if (resultsContainer) {
    const observer = new MutationObserver(() => {
      setTimeout(initStickyFilters, 100);
    });
    observer.observe(resultsContainer, { childList: true, subtree: true });
  }
});